"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.TabNavWrapper = exports.TabNavActions = exports.SelectWrapper = exports.SelectLinkWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TabNavWrapper = exports.TabNavWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "evtutk53"
} : {
  target: "evtutk53",
  label: "TabNavWrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;width:100%;position:relative;padding:0;margin:0;align-content:space-between;align-items:flex-end;&:after{content:'';display:block;width:100%;position:absolute;bottom:0;height:4px;background:", props.theme.border, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:TabNavWrapper;")));
const TabNavActions = exports.TabNavActions = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "evtutk52"
} : {
  target: "evtutk52",
  label: "TabNavActions"
})("position:absolute;right:0;bottom:1em;@media (max-width: ", _breakpoints.default.medium, "){bottom:0;padding:1em;&:after{display:none;}}");
const SelectLinkWrapper = exports.SelectLinkWrapper = /*#__PURE__*/(0, _base.default)("li", process.env.NODE_ENV === "production" ? {
  target: "evtutk51"
} : {
  target: "evtutk51",
  label: "SelectLinkWrapper"
})();
const SelectWrapper = exports.SelectWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "evtutk50"
} : {
  target: "evtutk50",
  label: "SelectWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1cickod",
  styles: "display:flex;flex-direction:column;gap:0.5em;&>span>div>ul>li>button{word-break:break-all;text-align:left;}"
} : {
  name: "1cickod",
  styles: "display:flex;flex-direction:column;gap:0.5em;&>span>div>ul>li>button{word-break:break-all;text-align:left;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const styles = exports.styles = {
  maxWidth: width => /*#__PURE__*/(0, _react.css)("max-width:", width, "px;" + (process.env.NODE_ENV === "production" ? "" : ";label:maxWidth;")),
  color: color => /*#__PURE__*/(0, _react.css)("& button{color:", color, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:color;")),
  underlineColor: color => /*#__PURE__*/(0, _react.css)("& button::after,& button:hover::after{background:", color, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:underlineColor;")),
  vertical: process.env.NODE_ENV === "production" ? {
    name: "1yrkr6r",
    styles: "flex-direction:column;align-items:flex-start;&:after{left:0;top:0;width:4px;height:100%;}& button::after,& button:hover::after{height:100%;width:4px;top:0;}"
  } : {
    name: "qxb6uv-vertical",
    styles: "flex-direction:column;align-items:flex-start;&:after{left:0;top:0;width:4px;height:100%;}& button::after,& button:hover::after{height:100%;width:4px;top:0;};label:vertical;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
var _default = exports.default = styles;